import Link from '@/components/link-component'
import PageWrapper from '@/components/page-wrapper'
import { smoothScroll } from '@/utils/dom'
import { dateFormat, slugify } from '@/utils/strings'
import { getLocale } from '@/utils/locale.ts'
import Routes from '@/constants/routes'

export default function Sitemap(props) {
  const locale = getLocale()

  const sections = [
    {
      title: 'Main Pages',
      data: props.landingPage,
    },
    {
      title: 'Help',
      data: props.helpArticle,
    },
    {
      title: 'Blog',
      data: props.blogPage,
    },
    {
      title: 'Events',
      data: props.events,
    },
    {
      title: 'Resources',
      data: [...(props.resourcePage || []), ...(props.resourceVideoPage || []), ...(props.googlePresentation || [])],
    },
    {
      title: 'Careers',
      data: props.careers,
    },
  ]

  return (
    <PageWrapper
      seo={props.seo}
      headerNav={props.headerNav}
      footerNav={props.footerNav}
      headerBanners={props.headerBanners}
      newsletterForm={props.newsletterForm}
    >
      <div className="mt-24 max-w-8xl mx-auto px-5 ">
        <div className="flex flex-col-reverse sm:flex-row gap-16">
          <article className="flex-1">
            {sections.map((section) => (
              <div className="border mb-16 dark:border-secondary-900" key={slugify(section.title)}>
                <div className="rounded-t bg-indigoBlue text-white p-2 dark:bg-secondary-900">
                  <h2 id={slugify(section.title)} className="my-2 ml-4">
                    {section.title}
                  </h2>
                </div>
                <div className="p-4">
                  <ul className="list-none">
                    {section.data?.map((item) => (
                      <li className="mb-2" key={item.loc}>
                        <Link
                          to={item.loc}
                          className="flex items-center gap-2 p-2 rounded-sm hover:bg-secondary-50 dark:hover:bg-secondary-900"
                        >
                          <span className="font-bwi text-[#777777] dark:text-secondary-200 mr-2 text-xl">&#xe96e;</span>
                          <div>
                            {item.title}
                            <div className="text-sm">{Routes.hostname + item.loc}</div>
                          </div>
                          <div className="text-sm text-secondary-300 flex-1 text-right">
                            {dateFormat(item.lastmod, locale)}
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </article>
          <div>
            <nav className="sm:sticky sm:top-20">
              <h2>Sections</h2>
              <ul className="list-none pb-4">
                {sections.map((section) => (
                  <li className="mb-2 ml-4" key={slugify(section.title)}>
                    <Link to={`#${slugify(section.title)}`} onClick={smoothScroll}>
                      {section.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}
